import { createFileRoute, Link } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'

import { DotsSix } from '@/components/icons'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Select } from '@/components/ui/select'

export const Route = createFileRoute('/_app/design')({
  component: RouteComponent,
  loader() {
    return {
      crumb: 'Design',
    }
  },
})

function RouteComponent() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <Page.Header>
        <Page.Title>Example Design System</Page.Title>
        <Page.Action>
          <Button asChild size='sm'>
            <Link from={Route.fullPath} to='/settings/user/create'>
              <PlusIcon /> Tambah Pengguna
            </Link>
          </Button>
        </Page.Action>
      </Page.Header>
      <Page.TwoColumn>
        <Page.Column>
          <ExampleCardSection />
        </Page.Column>
        <Page.Column>
          <ExampleFormField />
        </Page.Column>
      </Page.TwoColumn>
    </Page>
  )
}

function ExampleFormField() {
  return (
    <Card>
      <Card.Header>
        <Card.Title className=''>Form Example</Card.Title>
        <Card.Action>
          <Button size='icon-sm' variant='secondary'>
            <DotsSix />
          </Button>
        </Card.Action>
      </Card.Header>
      <Card.Content>
        <Select>
          <Select.Trigger className='w-56'>
            <Select.Value />
          </Select.Trigger>
          <Select.Content>
            <Select.Item value='1'>Item 1</Select.Item>
            <Select.Item value='2'>Item 2</Select.Item>
            <Select.Item value='3'>Item 3</Select.Item>
          </Select.Content>
        </Select>
      </Card.Content>
    </Card>
  )
}

function ExampleCardSection() {
  return (
    <Card>
      <Card.Header className='border-b'>
        <Card.Title>Card Title</Card.Title>
        <Card.Description>Card Description</Card.Description>
        <Card.Action>
          <Button asChild size='sm'>
            <Link from={Route.fullPath} to='/settings/user/create'>
              <PlusIcon /> Tambah Pengguna
            </Link>
          </Button>
        </Card.Action>
      </Card.Header>
      <Card.Content>
        <p>Card Content</p>
      </Card.Content>
      <Card.Footer className='border-t'>
        <Button asChild size='sm'>
          <Link from={Route.fullPath} to='/settings/user/create'>
            <PlusIcon /> Tambah Pengguna
          </Link>
        </Button>
      </Card.Footer>
    </Card>
  )
}
